<template>
  <div>
    <div>
      <h3>Fieldwork Request</h3>
    </div>
    <div class="wrapper">
      <div class="row row-wider">
        <div class="col-md-12" style="min-height: 150px;">
          <loader v-if="fieldworkRequestLoading"/>
          <div v-if="!fieldworkRequestLoading">
            <tabs nav-style="tabs" v-model="activeTabIndex">
                <tab header="Request">
                    <projectHeader v-if="project" :project="project" />
                    <fieldworkRequestHeader v-bind:fieldworkRequest="fieldworkRequest" />
                    <div style="margin-top: 20px;">
                        <form @submit.prevent="submit1" class="form-horizontal" data-vv-scope="tabRequest">
                            <loader v-if="fieldworkRequestLoading"/>
                            <fieldSet :disabled="!canSave">
                                <div class="form-group">
                                    <label class="col-md-3 control-label">Lead Agency Project No(s).</label>
                                    <div class="col-md-4">
                                        <input type="text" class="form-control" v-model="fieldworkRequest.leadAgencyProjectNumbers" placeholder="Lead Agency Project No(s).">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-3 control-label">Other Lead No(s).</label>
                                    <div class="col-md-8">
                                        <input type="text" class="form-control" v-model="fieldworkRequest.otherLeadNumbers" placeholder="Other Lead No(s).">
                                    </div>
                                </div>
                            </fieldSet>
                            <fieldset :disabled="formDisabled">
                                <div class="form-group">
                                    <label class="col-md-3 control-label">Field Org. Project No.</label>
                                    <div class="col-md-8">
                                        <textarea name="fieldOrganizationProjectNumber" class="form-control" v-model="fieldworkRequest.fieldOrganizationProjectNumber" placeholder="Field Org. Project No."></textarea>
                                    </div>
                                </div>
                                <div class="form-group" v-bind:class="{ 'has-error': errors.has('tabRequest.fieldOrganizationId') }">
                                    <label class="col-md-3 control-label">Field Org.</label>
                                    <div class="col-md-4">
                                        <select name="fieldOrganizationId" class="form-control" v-model="fieldworkRequest.fieldOrganizationId" @change="onChangeFieldOrganizationId()" v-validate="'required'" aria-required="true">
                                        <option disabled value="">Select a value</option>
                                        <option v-for="organization in organizationList" v-bind:value="organization.organizationId" :key="organization.organizationId">
                                            {{ organization.description}}
                                        </option>
                                        </select>
                                        <span v-show="errors.has('tabRequest.fieldOrganizationId')" class="has-error">Field Org. is required</span>
                                    </div>
                                </div>
                                <div class="form-group" v-show="fieldworkRequest.fieldOrganizationId != null && fieldworkRequest.fieldOrganizationId != ''" v-bind:class="{ 'has-error': errors.has('tabRequest.fieldOrganizationPointOfContactId') }">
                                    <label class="col-md-3 control-label">Field Org. POC</label>
                                    <div class="col-md-4">
                                        <select name="fieldOrganizationPointOfContactId" class="form-control" v-model="fieldworkRequest.fieldOrganizationPointOfContactId" @change="onChangeOrganizationContactId()" aria-required="true">
                                        <option value="">Select a value</option>
                                        <option v-for="organizationContact in organizationContactList" v-bind:value="organizationContact.organizationContactId" :key="organizationContact.organizationContactId">
                                            {{ organizationContact.lastName}} , {{ organizationContact.firstName }}
                                        </option>
                                        </select>
                                        <span v-show="errors.has('tabRequest.fieldOrganizationPointOfContactId')" class="has-error">Field Org. POC is required</span>
                                    </div>
                                </div>
                                <div class="form-group" v-if="selectedOrganizationContact != null">
                                    <label class="col-md-3 control-label">Field Org. Email</label>
                                    <div class="col-md-4">
                                        <input type="text" class="form-control" v-model="selectedOrganizationContact.email" placeholder="Field Org Email">
                                    </div>
                                </div>
                                <div class="form-group" v-if="hasFieldOrgPocOther">
                                    <label class="col-md-3 control-label">Field Org. POC Other</label>
                                    <div class="col-md-4">
                                        <input type="text" class="form-control" v-model="fieldworkRequest.fieldOrganizationPointOfContactOther" placeholder="Other POC Name">
                                    </div>
                                </div>
                                <div class="form-group" v-bind:class="{ 'has-error': errors.has('tabRequest.agencyId') }">
                                    <label class="col-md-3 control-label">Agency (Land Manager)</label>
                                    <div class="col-md-4">
                                        <select name="agencyId" class="form-control" v-model.lazy="fieldworkRequest.agencyId" @change="onChangeAgencyId()" v-validate="'required'" aria-required="true">
                                        <option disabled value="">Select a value</option>
                                        <option v-for="agency in agencyList" v-bind:value="agency.organizationId" :key="agency.organizationId">
                                            {{ agency.description }}
                                        </option>
                                        </select>
                                        <span v-show="errors.has('tabRequest.agencyId')" class="has-error">Agency (Land Manager)</span>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset :disabled="!canSave">
                                <div class="form-group" v-show="fieldworkRequest.agencyId != null && fieldworkRequest.agencyId != ''" v-bind:class="{ 'has-error': errors.has('tabRequest.agencyPointOfContactId') }">
                                    <label class="col-md-3 control-label">Agency POC</label>
                                    <div class="col-md-4">
                                        <select name="agencyPointOfContactId" class="form-control" v-model="fieldworkRequest.agencyPointOfContactId" @change="onChangeAgencyPointOfContactId()" aria-required="true">
                                        <option value="">Select a value</option>
                                        <option v-for="agencyContact in agencyContactList" v-bind:value="agencyContact.organizationContactId" :key="agencyContact.organizationContactId">
                                            {{ agencyContact.lastName}} , {{ agencyContact.firstName }}
                                        </option>
                                        </select>
                                        <span v-show="errors.has('tabRequest.agencyPointOfContactId')" class="has-error">Agency POC is required</span>
                                    </div>
                                </div>
                                <div class="form-group" v-if="selectedAgencyContact != null">
                                    <label class="col-md-3 control-label">Agency Email</label>
                                    <div class="col-md-4">
                                        <input type="text" class="form-control" v-model="selectedAgencyContact.email" placeholder="Agency Email">
                                    </div>
                                </div>
                                <div class="form-group" v-if="hasAgencyPocOther">
                                    <label class="col-md-3 control-label">Agency POC Other</label>
                                    <div class="col-md-4">
                                        <input type="text" class="form-control" v-model="fieldworkRequest.agencyPointOfContactOther" placeholder="Other POC Name">
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset :disabled="formDisabled">
                                <div class="form-group">
                                    <label class="col-md-3 control-label">Client/Proponent Project Name</label>
                                    <div class="col-md-8">
                                        <textarea class="form-control" v-model="fieldworkRequest.clientProjectName" placeholder="Client/Proponent Project Name"></textarea>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-3 control-label">Reason For Fieldwork</label>
                                    <div class="col-md-8">
                                        <textarea class="form-control" v-model="fieldworkRequest.reasonForFieldwork" placeholder="Reason For Fieldwork"></textarea>
                                    </div>
                                </div>
                                <div class="form-group" v-if="false">
                                    <label class="col-md-3 control-label">Brief Description</label>
                                    <div class="col-md-8">
                                        <textarea class="form-control" v-model="fieldworkRequest.briefDescription" placeholder="Brief Description"></textarea>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-3 control-label">Fieldwork Type</label>
                                    <div class="col-md-6">
                                        <div class="checkbox checkbox-inline" v-for="workType in workTypeList" :key="workType.workTypeId">
                                            <input type="checkbox" v-bind:id="'check_' + workType.workTypeId" v-model="rawWorkTypeList" v-bind:value="workType.workTypeId">
                                            <label v-bind:for="'check_' + workType.workTypeId" style="width:150px;">{{ workType.description }}</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-3 control-label">Scope (for surveys)</label>
                                    <div class="col-md-4">
                                        <select name="surveyScopeId" class="form-control" v-model="fieldworkRequest.surveyScopeId">
                                        <option value="">Select a value</option>
                                        <option v-for="surveyScope in surveyScopeList" v-bind:value="surveyScope.surveyScopeId" :key="surveyScope.surveyScopeId">
                                            {{ surveyScope.description}}
                                        </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group" v-bind:class="{ 'has-error': errors.has('tabRequest.proposedStartDate') }">
                                    <label class="col-md-3 control-label">Proposed Start Date</label>
                                    <div class="col-md-4">
                                        <el-date-picker v-model="fieldworkRequest.proposedStartDate" type="date" format="MM/dd/yyyy" placeholder="Select Date"></el-date-picker>
                                        <input name="proposedStartDate" type="hidden" v-model="fieldworkRequest.proposedStartDate" v-validate="'required'" />
                                        <div><span v-show="errors.has('tabRequest.proposedStartDate')" class="has-error">Proposed Start Date</span></div>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset :disabled="formDisabled && !hasAgencyRole">
                                <div class="form-group" v-bind:class="{ 'has-error': errors.has('tabRequest.proposedEndDate') }">
                                    <label class="col-md-3 control-label">Proposed End Date</label>
                                    <div class="col-md-4">
                                        <el-date-picker v-model="fieldworkRequest.proposedEndDate" type="date" format="MM/dd/yyyy" placeholder="Select Date"></el-date-picker>
                                        <input name="proposedEndDate" type="hidden" v-model="fieldworkRequest.proposedEndDate" v-validate="'required'" />
                                        <div><span v-show="errors.has('tabRequest.proposedEndDate')" class="has-error">Proposed End Date</span></div>
                                    </div>
                                </div>
                            </fieldset>
                            <fieldset :disabled="formDisabled">
                                <div class="form-group">
                                    <label class="col-md-3 control-label">Crew Chief(s)</label>
                                    <div class="col-md-4">
                                        <input type="text" class="form-control" v-model="fieldworkRequest.crewChiefs" placeholder="Crew Chief(s)">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="col-md-3 control-label">Crew Members</label>
                                    <div class="col-md-8">
                                        <textarea class="form-control" v-model="fieldworkRequest.crewMembers" placeholder="Crew Members"></textarea>
                                    </div>
                                </div>
                                <div class="form-group" v-if="!landOwnershipLegacy">
                                    <landOwnership :parentId="fieldworkRequestId" source='FieldworkRequest' :formDisabled="false" />
                                </div>
                                <div class="form-group" v-if="landOwnershipLegacy">
                                    <label class="col-md-3 control-label">Approximate Area (in whole acres)</label>
                                    <div class="col-md-8">
                                        <table border="0">
                                        <tr>
                                            <td style="width: 75px;"></td>
                                            <td style="text-align: center;">Intensive/Class III</td>
                                            <td style="text-align: center;">Extensive/Other</td>
                                            <td style="text-align: center;">Total</td>
                                        </tr>
                                        <tr>
                                            <td>Federal</td>
                                            <td style="width: 125px;"><input type="number" min="0" step=".1" class="form-control" v-model.number="fieldworkRequest.acresFederalIntensive"></td>
                                            <td style="width: 125px;"><input type="number" min="0" step=".1" class="form-control" v-model.number="fieldworkRequest.acresFederalExtensive"></td>
                                            <td style="text-align: center;">{{ addValues([fieldworkRequest.acresFederalIntensive, fieldworkRequest.acresFederalExtensive]) }}</td>
                                        </tr>
                                        <tr>
                                            <td>Other Public</td>
                                            <td><input type="number" class="form-control" min="0" step=".1" v-model.number="fieldworkRequest.acresOtherPublicIntensive"></td>
                                            <td><input type="number" class="form-control" min="0" step=".1" v-model.number="fieldworkRequest.acresOtherPublicExtensive"></td>
                                            <td style="text-align: center;">{{ addValues([fieldworkRequest.acresOtherPublicIntensive, fieldworkRequest.acresOtherPublicExtensive]) }}</td>
                                        </tr>
                                        <tr>
                                            <td>Private</td>
                                            <td><input type="number" class="form-control" min="0" step=".1" v-model.number="fieldworkRequest.acresPrivateIntensive"></td>
                                            <td><input type="number" class="form-control" min="0" step=".1" v-model.number="fieldworkRequest.acresPrivateExtensive"></td>
                                            <td style="text-align: center;">{{ addValues([fieldworkRequest.acresPrivateIntensive, fieldworkRequest.acresPrivateExtensive]) }}</td>
                                        </tr>
                                        <tr>
                                            <td style="height: 25px;">Total</td>
                                            <td style="text-align: center;">{{ addValues([fieldworkRequest.acresFederalIntensive, fieldworkRequest.acresOtherPublicIntensive, fieldworkRequest.acresPrivateIntensive]) }}</td>
                                            <td style="text-align: center;">{{ addValues([fieldworkRequest.acresFederalExtensive, fieldworkRequest.acresOtherPublicExtensive, fieldworkRequest.acresPrivateExtensive]) }}</td>
                                            <td style="text-align: center;"></td>
                                        </tr>
                                        </table>
                                    </div>
                                </div>
                            </fieldset>
                            <div class="form-group">
                                <label class="col-md-3 control-label">Field Org. Comments</label>
                                <div class="col-md-8">
                                    <!-- if user is NOT consultant or shpo admin, create readonly fieldOrganizationComments textarea that isn't tied to data,
                                    else, create fieldOrganizationComments textarea -->
                                    <textarea :disabled="!canSave" class="form-control" style="color: #555555;" v-if="(checkConsultantRole || checkAdminRole)" v-model="fieldworkRequest.fieldOrganizationComments" placeholder="Field Org. Comments"></textarea>
                                    <textarea disabled class="form-control" style="color: #555555;" v-else> {{ fieldworkRequest.fieldOrganizationComments}} </textarea>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-md-3 control-label">Lead Agency Comments</label>
                                <div class="col-md-8">
                                    <!-- if user is consultant, create readonly leadAgencyComments textarea that isn't tied to data,
                                    else, createleadAgencyComments textarea -->
                                    <textarea :disabled="!canSave" class="form-control" style="color: #555555;" v-if="(hasAgencyRole || checkAdminRole)" v-model="fieldworkRequest.leadAgencyComments" placeholder="Lead Agency Comments"></textarea>
                                    <textarea disabled class="form-control" style="color: #555555;" v-else> {{ fieldworkRequest.leadAgencyComments }} </textarea>
                                </div>
                            </div>

                            <div class="form-group" v-if="checkAdminRole">
                                <label class="col-md-3 control-label">&nbsp;</label>
                                <div class="col-md-8">
                                    <input type="checkbox" id="IsProjectInactive" v-model="fieldworkRequest.inactive">
                                    <label for="IsProjectInactive">Set Fieldwork Request Inactive?</label>
                                </div>
                            </div>

                            <div class="form-group">
                                <div class="col-md-3"></div>
                                <div class="col-md-8">
                                    <div v-show="errors.any()">
                                        <span class="has-error">Required fields must be filled in prior to submit</span>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-md-3"></div>
                                <div class="col-md-8">
                                    <div v-show="serverErrorList.length > 0">
                                        <span class="has-error">Validation issues must be corrected prior to submit</span>
                                        <ul class="has-error">
                                            <li v-for="serverError in serverErrorList" :key="serverError">{{ serverError }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="col-md-3">
                                </div>
                                <div class="col-md-3" v-if="canSave || hasAgencyRole">
                                    <button name="button2" class="btn btn-primary btn-block" type="submit" style="width:100px;">
                                        {{fieldworkRequestId ? 'Save' : 'Create'}}
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </tab>
                <tab header="Files" :disabled="fieldworkRequest.fieldworkRequestId == null">
                    <projectHeader v-if="project" :project="project" />
                    <fieldworkRequestHeader v-bind:fieldworkRequest="fieldworkRequest" />
                    <div style="margin-top: 20px;">
                        <media :mediaTypeId="mediaTypeIdFieldworkRequest" :parentId="fieldworkRequestId" :formDisabled="formDisabled" :loadOnMount="false" ref="media"></media>
                    </div>
                    <div style="margin-top: 20px;">
                        <hr />
                        <mediaLetter :mediaTypeId="mediaTypeIdFwrLetter" :parentId="fieldworkRequestId" :loadOnMount="false" ref="mediaLetter"></mediaLetter>
                    </div>
                </tab>
                <tab header="Location" :disabled="fieldworkRequest.fieldworkRequestId == null">
                    <loader v-if="locationTabLoading"/>
                    <projectHeader v-if="project" :project="project" />
                    <fieldworkRequestHeader v-bind:fieldworkRequest="fieldworkRequest" />
                    <fieldset :disabled="formDisabled">
                        <div style="margin-top: 20px;">
                            <div class="col-md-8"><h5>Counties</h5></div>
                            <div class="col-md-4">
                                <select name="countyToAdd" class="form-control" style="width: initial; display: inline;" v-model="countyToAdd">
                                    <option disabled value="">Select a County</option>
                                    <option v-for="county in countyList" v-bind:value="county.countyId" :key="county.countyId">
                                        {{ county.description}}
                                    </option>
                                </select>
                                <button name="button2" class="btn btn-primary" v-on:click="addCounty()" v-bind:disabled="countyToAdd == ''">Add</button>
                            </div>
                        </div>
                        <div>
                            <loader v-if="countyGridLoading"/>
                            <div ng-show="countyGridSpec.tableData.length > 0">
                                <v-client-table :data="countyGridSpec.tableData" :columns="countyGridSpec.columns" :options="countyGridSpec.options">
                                <template slot="delete" slot-scope="props">
                                    <div style="text-align: center;" v-if="!formDisabled">
                                        <a class="fa fa-ban" style="font-size: 18px;" v-on:click="deleteCountyRow(props.row.countyId)"></a>
                                    </div>
                                </template>
                                </v-client-table>
                            </div>
                        </div>
                        <div style="margin-top: 20px;">
                            <div class="col-md-8"><h5>Cadastral Location</h5></div>
                            <div class="col-md-4">
                                <button name="button3" class="btn btn-primary" v-on:click="showSectionModal()">Add Sections</button>
                                <modal title="Add Sections(s)" effect="fade/zoom" :value="sectionModalShow">
                                    <div slot="modal-header" class="modal-header">
                                        <h4 class="modal-title">Add PLSS Locations</h4>
                                    </div>
                                    <div slot="modal-body" class="modal-body">
                                        <plssComponent v-on:savePlss="savePlssFieldworkRequest" ref="plssComponent" v-bind:showTitle="false">
                                        </plssComponent>
                                    </div>
                                    <div slot="modal-footer" class="modal-footer">
                                        <button type="button" class="btn btn-default" @click="closeSectionModal" style="margin-bottom: 0px;">Exit</button>
                                    </div>
                                </modal>
                            </div>
                        </div>
                        <div>
                            <loader v-if="plssLocationGridLoading"/>
                            <div ng-show="plssLocationGridSpec.tableData.length > 0">
                                <v-client-table :data="plssLocationGridSpec.tableData" :columns="plssLocationGridSpec.columns" :options="plssLocationGridSpec.options">
                                <template slot="delete" slot-scope="props">
                                    <div style="text-align: center;" v-if="!formDisabled">
                                        <a class="fa fa-ban" style="font-size: 18px;" v-on:click="deletePlssLocation(props.row.fieldworkRequestPlssLocationId)"></a>
                                    </div>
                                </template>
                                </v-client-table>
                            </div>
                        </div>
                        <div style="margin-top: 20px;">
                            <div class="col-md-8"><h5>Map References</h5></div>
                            <div class="col-md-4">
                                <select name="mapReferenceToAdd" class="form-control" style="width: initial; display: inline;" v-model="mapReferenceToAdd">
                                    <option disabled value="">Select a Map Reference</option>
                                    <option v-for="mapReference in mapReferenceList" :key="mapReference.mapReferenceId" :value="mapReference.mapReferenceId">
                                        {{ mapReference.description}}
                                    </option>
                                </select>
                                <button name="button2" class="btn btn-primary" v-on:click="addMapReference()" v-bind:disabled="mapReferenceToAdd == ''">Add</button>
                            </div>
                        </div>
                        <div>
                            <loader v-if="mapReferenceGridLoading"/>
                            <div ng-show="mapReferenceGridSpec.tableData.length > 0">
                                <v-client-table :data="mapReferenceGridSpec.tableData" :columns="mapReferenceGridSpec.columns" :options="mapReferenceGridSpec.options">
                                <template slot="delete" slot-scope="props">
                                    <div style="text-align: center;" v-if="!formDisabled">
                                        <a class="fa fa-ban" style="font-size: 18px;" v-on:click="deleteMapReferenceRow(props.row.mapReferenceId)"></a>
                                    </div>
                                </template>
                                </v-client-table>
                            </div>
                        </div>
                    </fieldset>
                </tab>
                <tab header="Map" :disabled="fieldworkRequest.fieldworkRequestId == null" v-if="!isRestrictedRole">
                    <projectHeader v-if="project" :project="project" />
                    <fieldworkRequestHeader v-bind:fieldworkRequest="fieldworkRequest" />
                    <mapx :mediaTypeId="mediaTypeIdFieldworkRequest" :parentId="fieldworkRequestId" :loadOnMount="false" ref="mapx"></mapx>
                </tab>
                <tab header="Workflow" :disabled="fieldworkRequest.fieldworkRequestId == null">
                    <projectHeader v-if="project" :project="project" />
                    <fieldworkRequestHeader v-bind:fieldworkRequest="fieldworkRequest" />
                    <div style="margin-top: 20px;">
                        <workflow :fieldworkRequestErrors="errors" :workflowId="fieldworkRequestWorkflowId" :parentId="fieldworkRequestId" ref="workflow"
                        v-on:workflowOnBeforeSubmit="fieldworkRequestValidation" v-on:workflowOnSubmitSuccess="workflowOnSubmitSuccess" />
                    </div>
                    <div v-if="checkShpoRole" style="margin-top: 20px;">
                        <quickLetter :projectId="fieldworkRequest.projectId" :fieldWorkRequestId="fieldworkRequest.fieldworkRequestId"
                        :mediaTypeId="mediaTypeIdFwrLetter" :parentId="fieldworkRequestId"></quickLetter>
                    </div>
                    <div v-if="fieldworkRequest.fieldworkRequestId">
                        <button name="fwrReport" class="btn btn-primary" v-on:click="genFwrReport">Generate Report</button>
                    </div>
                </tab>
            </tabs>

            <div v-show="isDebug" style="margin-top: 20px;">
                <div>
                    <h3 class="text-danger">****** Debug ******</h3>
                </div>
                <div>
                    <h4>rawWorkTypeList: </h4>
                    <pre>{{ rawWorkTypeList }}</pre>
                </div>
                <div>
                    <h4>Validation errors: </h4>
                    <pre>{{ errors }}</pre>
                </div>
                <div>
                    <h4>fieldworkRequest: </h4>
                    <pre>{{ fieldworkRequest }}</pre>
                </div>
                <div>
                    <h4>selectedOrganizationContact: </h4>
                    <pre>{{ selectedOrganizationContact }}</pre>
                </div>
                <div>
                    <h4>selectedAgencyContact: </h4>
                    <pre>{{ selectedAgencyContact }}</pre>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

div.form-group {
  padding-left: 15px;
}

</style>

<script>
import loggingService from '../services/util/loggingService'
import fieldworkRequestService from '../services/fieldworkRequestService'
import organizationService from '../services/organizationService'
import organizationContactService from '../services/organizationContactService'
import workTypeService from '../services/workTypeService'
import surveyScopeService from '../services/surveyScopeService'
import mediaService from '../services/mediaService'
import countyService from '../services/countyService'
import mapReferenceService from '../services/mapReferenceService'
import workflowService from '../services/workflowService'
import projectService from '../services/projectService'
import roleService from '../services/roleService.js'
import userService from '@/services/userService.js'
import { mapState } from 'vuex'

import workflow from '../components/Workflow.vue'
import loader from '../components/Loader.vue'
import projectHeader from '../components/ProjectHeader.vue'
import fieldworkRequestHeader from '../components/FieldworkRequestHeader.vue'
import plssComponent from '../components/PlssComponent.vue'
import media from '../components/Media.vue'
import mediaLetter from '../components/MediaLetter.vue'
import quickLetter from '../components/QuickLetter.vue'
import { tab, tabs, modal } from 'vue-strap'
import _ from 'lodash/lodash.min.js'
import mapx from '@/views/MapNew'
import landOwnership from '../components/LandOwnership'

export default {
    components: {
        tabs,
        tab,
        modal,
        loader,
        fieldworkRequestHeader,
        workflow,
        projectHeader,
        plssComponent,
        media,
        mapx,
        mediaLetter,
        quickLetter,
        landOwnership
    },
    created () {
        if (this.isRestrictedRole) {
            this.tabsEnum = {
                request: 0,
                requestLoaded: false,
                files: 1,
                filesLoaded: false,
                location: 2,
                locationLoaded: false,
                map: -1,
                mapLoaded: false,
                workflow: 3,
                workflowLoaded: false
            }
        }
    },
    mounted () {
        loggingService.log(this.isDebug, 'FieldworkRequest', 'mounted')
        this.loadData()
    },
    computed: {
        fieldworkRequestId: function () {
            return this.$route.params.fieldworkRequestId
        },
        fieldworkRequestWorkflowId: function () {
            return workflowService.WorkflowEnum.FieldworkRequest
        },
        projectId: function () {
            if (this.fieldworkRequest) {
                return this.fieldworkRequest.projectId
            }

            return this.$route.query.projectId
        },
        mediaTypeIdFieldworkRequest: function () {
            return mediaService.mediaType.FieldworkRequest.toString()
        },
        mediaTypeIdFwrLetter: function () {
            return mediaService.mediaType.FieldworkRequestLetter
        },
        // compute current user info
        ...mapState({
            shpoUserDto: state => state.auth.shpoUserDto
        }),
        // check if user has consultant role
        checkConsultantRole: function () {
            var roles = [
                roleService.RoleEnum.ConsultantUser,
                roleService.RoleEnum.Administrator,
                roleService.RoleEnum.ShpoAdministrator
            ]
            return (this.shpoUserDto.roleList && userService.hasRoleCheck(this.shpoUserDto.roleList, roles))
        },
        // check if user has SHPO & SHPO RC admin roles
        checkAdminRole: function () {
            var adminRoles = [
                roleService.RoleEnum.Administrator,
                roleService.RoleEnum.ShpoAdministrator,
                roleService.RoleEnum.ShpoRcAdministrator,
                roleService.RoleEnum.Administrator
            ]
            return (this.shpoUserDto.roleList && userService.hasRoleCheck(this.shpoUserDto.roleList, adminRoles))
        },
        checkShpoRole: function () {
            var shpoRoleList = [
                roleService.RoleEnum.Administrator,
                roleService.RoleEnum.ShpoAdministrator,
                roleService.RoleEnum.ShpoCrApprovingUser,
                roleService.RoleEnum.ShpoCrDataEntryUser,
                roleService.RoleEnum.ShpoRcAdministrator,
                roleService.RoleEnum.ShpoRcApprovingUser,
                roleService.RoleEnum.ShpoRcDataEntryUser
            ]
            return (this.shpoUserDto.roleList && userService.hasRoleCheck(this.shpoUserDto.roleList, shpoRoleList))
        },
        hasAgencyRole: function () {
            return (this.shpoUserDto.roleList && userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.AgencyRoleList))
        },
        hasFieldOrgPocOther: function () {
            return this.fieldworkRequest && this.fieldworkRequest.fieldOrganizationId &&
            !this.fieldworkRequest.fieldOrganizationPointOfContactId
        },
        hasAgencyPocOther: function () {
            return this.fieldworkRequest && this.fieldworkRequest.agencyId &&
            !this.fieldworkRequest.agencyPointOfContactId
        },
        landOwnershipLegacy: function () {
            //date the system switched over from entering acres to entering land ownership. Set to August 15th, 2019
            return new Date(this.fieldworkRequest.createdDate) < new Date('2020-06-01T00:00:00')
        },
        isShpoReadOnly: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.ShpoReadOnlyRoleList)
        },
        formDisabled: function () {
            return this.isShpoReadOnly || (this.fieldworkRequestId && (this.fieldworkRequest.workflowStatusId !== 1000 && !this.checkAdminRole))
        },
        canSave: function () {
            return !this.formDisabled || (this.hasAgencyRole && this.fieldworkRequest.workflowStatusId === 1100)
        },
        isRestrictedRole: function () {
            return userService.hasRoleCheck(this.shpoUserDto.roleList, roleService.RestrictedRoleList)
        }
    },
    data: function () {
        return {
            isDebug: false,
            activeTabIndex: 0,
            project: null,
            fieldworkRequestLoading: false,
            locationTabLoading: false,
            countyGridLoading: false,
            mapReferenceGridLoading: false,
            fieldworkRequest: {},
            postSaveFieldworkRequest: null,
            organizationList: [],
            organizationContactList: [],
            selectedOrganizationContact: null,
            agencyList: [],
            agencyContactList: [],
            selectedAgencyContact: null,
            workTypeList: [],
            rawWorkTypeList: [],
            surveyScopeList: [],
            serverErrorList: [],
            countyList: [],
            countyToAdd: '',
            mapReferenceList: [],
            mapReferenceToAdd: '',
            countyGridSpec: {
                columns: ['countyDescription', 'createdBy', 'createdDate', 'delete'],
                tableData: [],
                options: {
                    dateFormat: 'MM/DD/YYYY, HH:mm A',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['createdDate'],
                    headings: {
                        countyDescription: 'County',
                        createdBy: 'Created By',
                        createdDate: 'Created Date',
                        delete: 'Delete'
                    }
                }
            },
            mapReferenceGridSpec: {
                columns: ['mapReferenceDescription', 'createdBy', 'createdDate', 'delete'],
                tableData: [],
                options: {
                    dateFormat: 'MM/DD/YYYY, HH:mm A',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['createdDate'],
                    headings: {
                        mapReferenceDescription: 'Map Reference',
                        createdBy: 'Created By',
                        createdDate: 'Created Date',
                        delete: 'Delete'
                    }
                }
            },
            plssLocationGridLoading: false,
            plssLocationGridSpec: {
                columns: ['township', 'townshipDirection', 'range', 'rangeDirection', 'section', 'meridianDescription', 'createdBy', 'createdDate', 'delete'],
                tableData: [],
                options: {
                    dateFormat: 'MM/DD/YYYY, HH:mm A',
                    perPage: 10,
                    perPageValues: [10, 25, 50, 100],
                    dateColumns: ['createdDate', 'modifiedDate'],
                    headings: {
                        mapReferenceDescription: 'Map Reference',
                        createdBy: 'Created By',
                        createdDate: 'Created Date',
                        delete: 'Delete'
                    }
                }
            },
            sectionModalShow: false,
            sectionModalSaveReady: false,
             // create Enum for each tab on the page, also keep track if the tab has been clicked and loaded
            tabsEnum: {
                request: 0,
                requestLoaded: false,
                files: 1,
                filesLoaded: false,
                location: 2,
                locationLoaded: false,
                map: 3,
                mapLoaded: false,
                workflow: 4,
                workflowLoaded: false
            }
        }
    },
    watch: {
        activeTabIndex: function (val) {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'watch.activeTabIndex: ' + val)
            switch (val) {
            case this.tabsEnum.request: //Request
                break
            case this.tabsEnum.files: //Files tab
                if (!this.tabsEnum.filesLoaded) {
                    this.$refs.media.loadMedia()
                    this.$refs.mediaLetter.loadMedia()
                }
                this.tabsEnum.filesLoaded = true
                break
            case this.tabsEnum.location: //Location tab
                this.locationTabLoading = true
                Promise.all([ this.loadCountyList(), this.loadMapReferenceList() ]).then(results => {
                    this.locationTabLoading = false

                    this.loadFieldworkRequestCountyList(this.fieldworkRequest.fieldworkRequestId)
                    this.loadFieldworkRequestMapReferenceList(this.fieldworkRequest.fieldworkRequestId)
                    this.loadFieldworkRequestPlssLocationResultList(this.fieldworkRequest.fieldworkRequestId)
                })
                break
            case this.tabsEnum.map: //Map
                if (!this.tabsEnum.mapLoaded) this.$refs.mapx.createMap()
                this.tabsEnum.mapLoaded = true
                break
            case this.tabsEnum.workflow: //Workflow
                if (!this.tabsEnum.workflowLoaded) {
                    this.$refs.workflow.loadData()
                    loggingService.log(this.isDebug, 'FieldworkRequest', 'watch.activeTabIndex: ' + val + ', called: workflow.loadData')
                }
                this.tabsEnum.workflowLoaded = true
                break
            }
        },
        projectId: function (val) {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'watch.projectId: ' + val)
        }
    },
    methods: {
        loadFieldWorkRequest (fieldworkRequestId) {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'loadFieldWorkRequest')
            var handle = this
            return fieldworkRequestService.get(this.$http, fieldworkRequestId).then(function (response) {
                loggingService.log(handle.isDebug, 'FieldworkRequest', 'loadFieldWorkRequest - complete')

                handle.fieldworkRequest = response.data
                if (handle.fieldworkRequest.workTypeList) {
                    handle.rawWorkTypeList = handle.fieldworkRequest.rawWorkTypeList
                }

                var promiseList = []

                if (handle.fieldworkRequest.fieldOrganizationId != null) {
                    promiseList.push(handle.onChangeFieldOrganizationId(handle.fieldworkRequest.fieldOrganizationId))
                }

                if (handle.fieldworkRequest.agencyId != null) {
                    promiseList.push(handle.onChangeAgencyId(handle.fieldworkRequest.agencyId))
                }

                promiseList.push(handle.loadProject(handle, handle.fieldworkRequest.projectId))

                return Promise.all(promiseList).then(response2 => {
                    if (!handle.fieldworkRequest.fieldOrganizationProjectNumber) {
                        handle.fieldworkRequest.fieldOrganizationProjectNumber = handle.project.fieldOrgNumber
                    }
                    if (handle.project.name && !handle.fieldworkRequest.clientProjectName) {
                        handle.fieldworkRequest.clientProjectName = handle.project.name
                    }
                })
            })
        },
        loadProject (handle, projectId) {
            loggingService.log(handle.isDebug, 'FieldworkRequest', 'loadProject')

            return projectService.search(handle.$http, { projectId: projectId }).then(function (response) {
                loggingService.log(handle.isDebug, 'FieldworkRequest', 'loadProject - complete')

                handle.project = response.data.length > 0 ? response.data[0] : []
            })
        },
        addValues (list) {
            if (Array.isArray(list)) {
                var result = 0
                for (var i = 0; i < list.length; i++) {
                    result += isNaN(list[i]) ? 0 : list[i]
                }
                return result
            } else {
                return -1
            }
        },
        loadOrganizations () {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'loadOrganizations')
            this.organizationList = []
            var handle = this
            return organizationService.listLookup(this.$http).then(function (response) {
                loggingService.log(handle.isDebug, 'FieldworkRequest', 'loadOrganizations - complete')
                handle.organizationList = response.data
            })
        },
        loadOrganizationContacts (organizationId) {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'loadOrganizationContacts, organizationId: ' + organizationId)
            this.organizationContactList = []

            if (organizationId || organizationId !== '') {
                var handle = this
                return organizationContactService.listLookup(this.$http, organizationId).then(function (response) {
                    handle.organizationContactList = response.data

                    handle.selectedOrganizationContact = handle.getSelectedOrganizationContact(handle.organizationContactList, handle.fieldworkRequest.fieldOrganizationPointOfContactId)
                    loggingService.log(handle.isDebug, 'FieldworkRequest', 'loadOrganizationContacts, selectedOrganizationContact: ' + handle.selectedOrganizationContact)
                })
            }
        },
        loadAgencyList () {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'loadAgencyList')

            //This needs to be more sophisticated and pull the lead agencies for a particular user
            this.agencyList = []
            var handle = this
            return organizationService.listLookup(this.$http).then(function (response) {
                loggingService.log(handle.isDebug, 'FieldworkRequest', 'loadAgencyList - complete')

                handle.agencyList = response.data
            })
        },
        loadAgencyContacts (organizationId) {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'loadAgencyContacts, organizationId: ' + organizationId)
            this.agencyContactList = []

            if (organizationId || organizationId !== '') {
                var handle = this
                return organizationContactService.listLookup(this.$http, organizationId).then(function (response) {
                    handle.agencyContactList = response.data

                    handle.selectedAgencyContact = handle.getSelectedOrganizationContact(handle.agencyContactList, handle.fieldworkRequest.agencyPointOfContactId)
                    loggingService.log(handle.isDebug, 'FieldworkRequest', 'loadOrganizationContacts, selectedAgencyContact: ' + handle.selectedAgencyContact)
                })
            }
        },
        loadWorkTypeList () {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'loadWorkTypeList')
            this.workTypeList = []
            var handle = this
            return workTypeService.listLookup(this.$http).then(function (response) {
                loggingService.log(handle.isDebug, 'FieldworkRequest', 'loadWorkTypeList - complete')

                handle.workTypeList = response.data
            })
        },
        loadSurveyScopeList () {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'loadSurveyScopeList')
            this.surveyScopeList = []
            var handle = this
            return surveyScopeService.listLookup(this.$http).then(function (response) {
                loggingService.log(handle.isDebug, 'FieldworkRequest', 'loadSurveyScopeList - complete')

                handle.surveyScopeList = response.data
            })
        },
        loadFieldworkRequestCountyList (fieldworkRequestId) {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'loadFieldworkRequestMedia')

            var handle = this
            this.countyGridLoading = true
            fieldworkRequestService.listFieldworkRequestCountyList(this.$http, this.fieldworkRequest.fieldworkRequestId).then(function (response) {
                handle.countyGridSpec.tableData = response.data
                handle.countyGridLoading = false
            })
        },
        loadFieldworkRequestMapReferenceList (fieldworkRequestId) {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'loadFieldworkRequestMapReferenceList')

            var handle = this
            this.mapReferenceGridLoading = true
            fieldworkRequestService.listFieldworkRequestMapReferenceList(this.$http, this.fieldworkRequest.fieldworkRequestId).then(function (response) {
                handle.mapReferenceGridSpec.tableData = response.data
                handle.mapReferenceGridLoading = false
            })
        },
        loadFieldworkRequestPlssLocationResultList (fieldworkRequestId) {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'loadFieldworkRequestPlssLocationResultList')

            var handle = this
            this.plssLocationGridLoading = true
            fieldworkRequestService.listFieldworkRequestPlssLocationResultDto(this.$http, this.fieldworkRequest.fieldworkRequestId).then(function (response) {
                handle.plssLocationGridSpec.tableData = response.data
                handle.plssLocationGridLoading = false
            })
        },
        loadCountyList () {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'loadCountyList')

            var handle = this
            countyService.listLookup(this.$http).then(function (response) {
                handle.countyList = response.data
                return response
            })
        },
        loadMapReferenceList () {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'loadMapReferenceList')

            var handle = this
            mapReferenceService.listLookup(this.$http).then(function (response) {
                handle.mapReferenceList = response.data
                return response
            })
        },
        loadData () {
            this.fieldworkRequestLoading = true

            Promise.all([ this.loadOrganizations(),
                this.loadAgencyList(),
                this.loadWorkTypeList(),
                this.loadSurveyScopeList()
            ]).then(results => {
                var handle = this
                if (this.fieldworkRequestId) {
                    loggingService.log(this.isDebug, 'FieldworkRequest', 'mounted, post promises, fieldworkRequestId: ' + this.fieldworkRequestId)
                    this.loadFieldWorkRequest(this.fieldworkRequestId).then(function (response) {
                        handle.fieldworkRequestLoading = false
                        loggingService.log(handle.isDebug, 'FieldworkRequest', 'mounted, loading complete: ' + handle.fieldworkRequestId)
                    })
                } else if (this.$route.query.projectId) {
                    this.fieldworkRequest.projectId = this.$route.query.projectId
                    this.loadProject(this, this.$route.query.projectId)
                    handle.fieldworkRequestLoading = false
                    loggingService.log(this.isDebug, 'FieldworkRequest', 'mounted, loading complete: ' + handle.fieldworkRequestId)
                } else {
                    loggingService.log(this.isDebug, 'FieldworkRequest', 'mounted, required route parameter not present')
                    this.$router.push('/Projects')
                }
            })
        },
        onChangeFieldOrganizationId (val) {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'onChangeOrganizationId')
            this.selectedOrganizationContact = null
            if (this.fieldworkRequest.fieldOrganizationId == null) {
                this.organizationContactList = []
            } else {
                return this.loadOrganizationContacts(this.fieldworkRequest.fieldOrganizationId)
            }
        },
        onChangeOrganizationContactId () {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'onChangeOrganizationContactId')
            this.selectedOrganizationContact = this.getSelectedOrganizationContact(this.organizationContactList, this.fieldworkRequest.fieldOrganizationPointOfContactId)
        },
        onChangeAgencyId () {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'onChangeAgencyId')
            this.selectedAgencyContact = null
            if (this.fieldworkRequest.agencyId == null) {
                this.agencyContactList = []
            } else {
                return this.loadAgencyContacts(this.fieldworkRequest.agencyId)
            }
        },
        onChangeAgencyPointOfContactId () {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'onChangeAgencyPointOfContactId')
            this.selectedAgencyContact = this.getSelectedOrganizationContact(this.agencyContactList, this.fieldworkRequest.agencyPointOfContactId)
        },
        getSelectedOrganizationContact (organizationContactList, organizationContactId) {
            return _.find(organizationContactList, function (item) { return item.organizationContactId === organizationContactId })
        },
        submit1 () {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'submit1')
            var handle = this

            this.$validator.validateAll('tabRequest').then(result => {
                if (!result) {
                    loggingService.log(this.isDebug, 'FieldworkRequest', 'submit1 - invalid form')
                    return
                } else {
                    loggingService.log(this.isDebug, 'FieldworkRequest', 'submit1 - form validated')
                    this.serverErrorList = []
                    this.fieldworkRequest.rawWorkTypeList = handle.rawWorkTypeList
                    handle.fieldworkRequestLoading = true
                    fieldworkRequestService.put(this.$http, this.fieldworkRequest).then(function (response) {
                        var result = response.data
                        if (result.isValid) {
                            handle.fieldworkRequest = result.objectList[0]
                            handle.$router.push('/FieldworkRequest/' + handle.fieldworkRequest.fieldworkRequestId)
                            //handle.activeTabIndex = 1 //Go to next tab after save
                            handle.loadData()
                            //handle.fieldworkRequestLoading = false
                        } else {
                            handle.serverErrorList = result.messages
                            handle.fieldworkRequestLoading = false
                        }
                    })
                }
            })
        },
        submit2 () {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'submit2')

            this.$validator.validateAll('tabFiles').then(result => {
                if (result) {
                    loggingService.log(this.isDebug, 'FieldworkRequest', 'submit2 - form validated')

                    var handle = this
                    fieldworkRequestService.putFile(this.$http, this.fieldworkRequest.fieldworkRequestId, this.$refs['newFile'].files[0]).then(function (response) {
                        loggingService.log(handle.isDebug, 'FieldworkRequest', 'submit2 - upload complete')

                        handle.$refs['newFile'].value = ''

                        //refresh media after upload
                        handle.loadFieldworkRequestMedia(handle.fieldworkRequest.fieldworkRequestId)
                    })
                } else {
                    loggingService.log(this.isDebug, 'FieldworkRequest', 'submit2 - invalid form')
                }
            })
        },
        mediaDownloadRow (mediaId, mediaTypeId, parentId, filename) {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'mediaDownloadRow - mediaId: ' + mediaId + ', mediaTypeId: ' + mediaTypeId + ', parentId: ' + parentId)

            mediaService.get(this.$http, mediaId, mediaTypeId, null, parentId).then(function (response) {
                mediaService.saveFileToDownload(response, filename)
            })
        },
        addCounty () {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'addCounty - countyToAdd: ' + this.countyToAdd)
            var handle = this
            fieldworkRequestService.addCounty(this.$http, this.fieldworkRequest.fieldworkRequestId, this.countyToAdd).then(function (response) {
                handle.loadFieldworkRequestCountyList()
            })
        },
        deleteCountyRow (countyId) {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'deleteCountyRow - countyId: ' + countyId)
            var handle = this
            fieldworkRequestService.deleteCounty(this.$http, this.fieldworkRequest.fieldworkRequestId, countyId).then(function (response) {
                handle.loadFieldworkRequestCountyList()
            })
        },
        addMapReference () {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'addMapReference - mapReferenceToAdd: ' + this.mapReferenceToAdd)
            var handle = this
            fieldworkRequestService.addMapReference(this.$http, this.fieldworkRequest.fieldworkRequestId, this.mapReferenceToAdd).then(function (response) {
                handle.loadFieldworkRequestMapReferenceList()
            })
        },
        deleteMapReferenceRow (mapReferenceId) {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'deleteMapReferenceRow - mapReferenceId: ' + mapReferenceId)
            var handle = this
            fieldworkRequestService.deleteMapReference(this.$http, this.fieldworkRequest.fieldworkRequestId, mapReferenceId).then(function (response) {
                handle.loadFieldworkRequestMapReferenceList()
            })
        },
        showSectionModal () {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'showSectionModal')

            this.sectionModalShow = true
        },
        closeSectionModal () {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'closeSectionModal')

            this.sectionModalShow = false
        },
        savePlssFieldworkRequest () {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'savePlssFieldworkRequest:  ' + this.fieldworkRequest.fieldworkRequestId)
            var plss = this.$refs['plssComponent'].plssData

            fieldworkRequestService.putPlss(this.$http, this.fieldworkRequest.fieldworkRequestId, plss).then(response => {
                loggingService.log(this.isDebug, 'FieldworkRequest', 'savePlssFieldworkRequest - complete')
                this.sectionModalShow = false

                this.loadFieldworkRequestPlssLocationResultList(this.fieldworkRequest.fieldworkRequestId)
            })
        },
        deletePlssLocation (fieldworkRequestPlssLocationId) {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'delete plss Location :' + fieldworkRequestPlssLocationId)
            fieldworkRequestService.deletePlssLocation(this.$http, fieldworkRequestPlssLocationId).then(response => {
                this.loadFieldworkRequestPlssLocationResultList(this.fieldworkRequest.fieldworkRequestId)
            })
        },
        workflowOnSubmitSuccess (submitValidationResult) {
            loggingService.log(this.isDebug, 'FieldworkRequest', 'workflowOnSubmitSuccess')
            loggingService.logRaw(submitValidationResult)

            //trigger media letter refresh if letter gen is triggered
            if (submitValidationResult.letterGenTriggered && this.$refs.mediaLetter) {
                this.$refs.mediaLetter.autoRefreshMedia()
            }
            if (submitValidationResult && submitValidationResult.objectList && submitValidationResult.objectList.length > 1) {
                var o = submitValidationResult.objectList[1]
                if (o && o.fileSearchId) {
                    this.$router.push('/FileSearch/' + o.fileSearchId)
                }
            }
        },
        // run validation when workflow is submitted
        fieldworkRequestValidation () {
            loggingService.log(this.isDebug, 'FieldWorkRequest', 'fieldworkRequest form validation')
            this.$validator.validateAll('tabRequest').then(result => {
                if (result) {
                    loggingService.log(this.isDebug, 'FieldworkRequest', 'submit1 - form validated')
                } else {
                    loggingService.log(this.isDebug, 'FieldworkRequest', 'submit1 - invalid form')
                }
            })
        },
        genFwrReport () {
            if (this.fieldworkRequest.fieldworkRequestId) {
                fieldworkRequestService.fieldworkRequestReportGen(this.$http, this.fieldworkRequest.fieldworkRequestId).then(response => {
                    mediaService.saveFileToDownload(response, 'FieldworkRequestReport.pdf')
                })
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// FieldworkRequest.vue?80bdbd7e